import { Advisory } from '../model/advisory';
import { Undefinedable } from 'gocclr-shared-ui/dist/helpers';
import { createGlobalState } from 'react-hooks-global-state';
import { clearHeaderPromise } from '../services/header.service';
import { clearFooterPromise } from '../services/footer.service';

export interface AppState {
    rawHeader: Undefinedable<string>;
    rawAlerts: Undefinedable<string>;
    rawFooter: Undefinedable<string>;
    advisories: Advisory[];
}

const initialState: AppState = {
    rawAlerts: undefined,
    rawFooter: undefined,
    rawHeader: undefined,
    advisories: []
};

const { useGlobalState, getGlobalState, setGlobalState } = createGlobalState(initialState);
export const useAppState = useGlobalState;
export const getAppState = getGlobalState;
export const setAppState = setGlobalState;

export function setHeaderHtml(html: string) {
    setGlobalState('rawHeader', html);
}

export function setAlertsHtml(html: string) {
    setGlobalState('rawAlerts', html);
}

export function setFooterHtml(html: string) {
    setGlobalState('rawFooter', html);
}

export function clearHeaderFooter() {
    setGlobalState('rawAlerts', undefined);
    setGlobalState('rawHeader', undefined);
    setGlobalState('rawFooter', undefined);

    clearHeaderPromise();
    clearFooterPromise();
}
